import React from 'react';
import { FDBox, FDDivider, FDStack } from '@facet-wealth/design';

export const SmallDivider = () => (
  <FDStack direction={'column'} alignItems={'center'} paddingY={2} paddingX={8}>
    <FDBox width={'100px'}>
      <FDDivider />
    </FDBox>
  </FDStack>
);
